// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__gwswk","content":"Layout_content__37Mbc","main":"Layout_main__DAfN2"};